import React, { useEffect } from 'react';
import Spacer from './Spacer';
import './policy.css';

function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="policy-container py-5">
      <header>
        <h1 className="text-center mb-4">Privacy Policy</h1>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-10 col-md-10 col-sm-12">
              <p className="lead">
                <strong>Pool 4 Real Privacy Policy</strong>
                <Spacer />
                Effective Date: May 11, 2026
                <Spacer />
                Pool 4 Real is a social, map, team, tournament, marketplace, and business-discovery app for billiards, pool, and sinuca players. This policy explains how Pool 4 Real collects, uses, stores, and deletes user data.
                <Spacer />

                <strong>1. Information We Collect</strong>
                <Spacer />
                We may collect account information such as email address, user ID, display name, nickname, profile details, profile photo, and authentication provider information. We may collect user-generated content such as posts, messages, listings, business profiles, team and tournament content, ads, images, favorites, reactions, reports, and support requests.
                <Spacer />
                For Android closed testing requests, we may collect a tester's name, contact email, Google Play email, preferred language, country or region, testing notes, and consent to be contacted about testing access.
                <Spacer />
                We may collect location information when users enable location-related features, such as finding nearby players, businesses, events, tournaments, listings, or map content. Pool 4 Real does not intend to publicly share a user's live precise location with other users.
                <Spacer />
                We may collect app activity, app preferences, device tokens, diagnostics, analytics, crash/performance data, and security-related logs to operate and protect the service.
                <Spacer />

                <strong>2. How We Use Information</strong>
                <Spacer />
                We use information to operate the app, authenticate users, show profiles/posts/listings/businesses/events/teams/tournaments, enable messaging, improve safety, provide support, personalize app experiences, prevent fraud or abuse, maintain security, send notifications, and comply with legal obligations.
                <Spacer />
                Android closed testing request information is used to review tester interest, add approved Google Play accounts to closed testing, send setup instructions, collect feedback, and manage testing communications.
                <Spacer />

                <strong>3. User-Generated Content and Social Features</strong>
                <Spacer />
                Pool 4 Real includes social features such as profiles, posts, messaging, teams, tournaments, listings, and business pages. Some user-generated content may be visible to other users depending on how the feature works. Users are responsible for the content they submit.
                <Spacer />

                <strong>4. Businesses, Ads, Adult Environments, and Alcohol References</strong>
                <Spacer />
                Pool 4 Real may display pool halls, bars, billiards businesses, event venues, promotions, or business advertisements. Some real-world locations or promotions may involve alcohol-serving environments or adult-oriented settings. Pool 4 Real is not intended for children.
                <Spacer />

                <strong>5. Third-Party Services</strong>
                <Spacer />
                We use third-party services such as Firebase, Google authentication, Google Maps/Places, analytics, cloud storage, cloud functions, notification services, and payment or billing providers when enabled. These services may process data according to their own terms and policies.
                <Spacer />

                <strong>6. Security</strong>
                <Spacer />
                We use reasonable safeguards to protect user data. Data transmitted by the app is intended to be encrypted in transit. No online service can guarantee absolute security.
                <Spacer />

                <strong>7. Blocking, Reporting, and Safety Controls</strong>
                <Spacer />
                Pool 4 Real may provide tools to block users, block conversations, hide content, or report users or user-generated content. Blocking may limit visibility and communications between users.
                <Spacer />

                <strong>8. Data Retention</strong>
                <Spacer />
                We retain user data as long as necessary to operate the service, comply with legal obligations, prevent abuse or fraud, resolve disputes, maintain safety, support business operations, and meet security or accounting requirements.
                <Spacer />

                <strong>9. Account and Data Deletion</strong>
                <Spacer />
                Users can request account deletion and associated data deletion from inside the Pool 4 Real app or from our public deletion page at <a href="https://pool4real.com/delete-account">https://pool4real.com/delete-account</a>.
                <Spacer />
                In the Android app, users can go to <strong>Settings</strong>, then <strong>Support & Legal</strong>, then select <strong>Delete account & data</strong>. Users who cannot access the app can email <a href="mailto:rack@pool4real.com">rack@pool4real.com</a> from the email address connected to their Pool 4 Real account.
                <Spacer />
                When an account deletion request is processed, Pool 4 Real deletes or anonymizes account-linked data where reasonably possible, including account/profile records, authentication account, posts, images, messages or inbox records tied to the account, listings, business profiles, map ads, teams, tournaments, favorites, device tokens, and app setup/preferences.
                <Spacer />
                Some records may be retained when required for legal compliance, fraud prevention, security, billing, abuse prevention, tax/accounting obligations, dispute resolution, safety, moderation, or to preserve the integrity of teams, tournaments, or business records. Retained data is limited to what is necessary and kept only for the required period.
                <Spacer />
                Users may also request deletion of specific data without deleting their entire account by contacting <a href="mailto:rack@pool4real.com">rack@pool4real.com</a>.
                <Spacer />

                <strong>10. User Rights</strong>
                <Spacer />
                Users may request access, correction, or deletion of their information by using the app controls or contacting us. We may verify account ownership before processing requests.
                <Spacer />

                <strong>11. Changes to This Policy</strong>
                <Spacer />
                We may update this policy from time to time. Updates will be posted on this page.
                <Spacer />

                <strong>12. Contact Us</strong>
                <Spacer />
                For privacy, account deletion, data deletion, safety, or support questions, contact us at <a href="mailto:rack@pool4real.com">rack@pool4real.com</a>.
              </p>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default PrivacyPolicy;
